module.exports = __webpack_public_path__ + "img/activity.b7d9cc7f.svg";